import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=4c411c52&scoped=true&"
import script from "./Window.vue?vue&type=script&lang=js&"
export * from "./Window.vue?vue&type=script&lang=js&"
import style0 from "./Window.vue?vue&type=style&index=0&id=4c411c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c411c52",
  null
  
)

export default component.exports